import { RouteConfig } from 'vue-router';


const AppSetting = () => import(/* webpackChunkName: "App" */  '../app/views/app-setting.vue');


const routers: RouteConfig[] = [
    {
        path: "app-setting",
        component: AppSetting
    },
    {
        path: '',
        redirect: 'app-setting'
    },
];

export default routers;
